export default __webpack_public_path__ + "static/media/live.c91d7ecf.svg";